import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./organization-contract.scss";
import {
    OrgContractList,
    AddOrgContract,
    RemoveOrgContract,
    GetFileBase64,
} from "../../../../api";
import Dropzone from "react-dropzone";
import imgUpload from "../../../../../images/upload.png";
import Loader from "../../../loader/loader";
import { confirmAlert } from "react-confirm-alert";
import ShowDocsModal from "../../../modals/show-document/show-docs";

class OrganizationContract extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contractList: {},
            showSpinner: true,
            uploadFileError: "",
            docModal: false,
            docModalFile: null,
            docModalFileType: "",
        };
        this.uploads = [];
    }
    componentDidMount() {
        this.GetContractList();
    }

    handleDrop = (event) => {
        this.uploads = event;
        this.handleFileUpload();
    };

    handleDropReject(event) {
        this.setState({
            uploadFileError: "Something wrong please try again..",
        });
    }

    GetContractList() {
        const searchTerm = {
            org_id: this.props.org_id,
        };
        this.setState({ showSpinner: true });
        OrgContractList(searchTerm)
            .then((response) => {
                if (response.success === true) {
                    this.setState({
                        contractList: response.data,
                        showSpinner: false,
                    });
                } else {
                    this.setState({ contractList: {}, showSpinner: false });
                }
            })
            .catch((error) =>
                this.setState({ contractList: {}, showSpinner: false }),
            );
    }

    handleFileUpload() {
        let selectedFile = this.uploads;
        //Check File is not Empty
        if (selectedFile.length > 0) {
            this.setState({ showSpinner: true });
            const fileTypes = [
                // Images and PDF
                "jpg",
                "jpeg",
                "png",
                "pdf",
                // MS Extensions
                "docx",
                "xls",
                "xlsx",
                "ppt",
                "pptx",
                "doc",
                // Mac OS extensions
                "pages",
                "numbers",
                "key",
            ];
            let fileToLoad = selectedFile[0];
            let fileName = "";
            fileName = fileToLoad.name;
            let filename_type = fileName.split(".");
            // Check the file type
            let file_type_lenght = filename_type.length - 1;
            if (
                filename_type.length > 1 &&
                fileTypes.findIndex(
                    (d) => d == filename_type[file_type_lenght],
                ) != -1
            ) {
                this.setState({ uploadFileError: "" });
            } else {
                this.setState({
                    uploadFileError:
                        "Please check the format of the file before upload. It should be only " +
                        fileTypes.join(", "),
                    showSpinner: false,
                });
                return;
            }

            let formData = new FormData();
            formData.append("file", selectedFile[0]);
            formData.append("org_id", this.props.org_id);

            AddOrgContract(formData)
                .then((response) => {
                    if (response.success === true) {
                        this.GetContractList();
                        this.setState({ uploadFileSuccess: response.message });
                        setTimeout(() => {
                            this.setState({ uploadFileSuccess: "" });
                        }, 5000);
                    } else {
                        this.setState({
                            uploadFileError: response.message,
                            showSpinner: false,
                        });
                    }
                })
                .catch((error) => {
                    if (error.status) {
                        if (error.status === 403) {
                            this.setState({
                                uploadFileError:
                                    "Invalid file format please upload a valid file",
                                showSpinner: false,
                            });
                        } else {
                            this.setState({
                                uploadFileError:
                                    "Something wrong please try again...",
                                showSpinner: false,
                            });
                        }
                    } else {
                        this.setState({
                            uploadFileError:
                                "Invalid file format please upload a valid file",
                            showSpinner: false,
                        });
                    }
                });
        }
    }

    handleDelete = (evt) => {
        confirmAlert({
            title: "Delete Contract",
            message: "Are you sure you want to delete the contract?",
            buttons: [
                { label: "Yes", onClick: () => this.deleteRecord(evt) },
                { label: "No" },
            ],
        });
    };

    deleteRecord(id) {
        this.setState({ showSpinner: true });
        RemoveOrgContract(id)
            .then((response) => {
                if (response.success === true) {
                    this.GetContractList();
                } else {
                    this.setState({
                        uploadFileError: response.message,
                        showSpinner: false,
                    });
                }
            })
            .catch((error) =>
                this.setState({
                    uploadFileError: "Something wrong please try again...",
                    showSpinner: false,
                }),
            );
    }

    openDocModal = (file) => {
        this.setState({ showSpinner: true });
        let pathSplit = file.path.split(".");
        let fileExt = pathSplit[pathSplit.length - 1];
        GetFileBase64(file.id)
            .then((response) => {
                if (response.success === true) {
                    file.encFile = response.encFile;
                    this.setState({
                        docModal: true,
                        docModalFile: file,
                        docModalFileType: fileExt,
                        uploadFileError: "",
                        showSpinner: false,
                    });
                } else {
                    this.setState({
                        uploadFileError: response.message,
                        showSpinner: false,
                    });
                }
            })
            .catch((error) =>
                this.setState({
                    uploadFileError: "Something wrong please try again...",
                    showSpinner: false,
                }),
            );
    };

    closeDocModal = () => {
        this.setState({
            docModal: false,
            docModalFile: null,
            docModalFileType: "",
        });
    };

    render() {
        const {
            contractList,
            showSpinner,
            docModalFile,
            docModal,
            docModalFileType,
        } = this.state;
        return (
            <>
                <div className="contractDragndrop">
                    <div className="heading">
                        <p>
                            {" "}
                            Organization Documents{" "}
                            <span>({contractList.length})</span>
                        </p>
                    </div>
                    <Dropzone
                        onDrop={(e) => this.handleDrop(e)}
                        onDropRejected={(e) => this.handleDropReject(e)}
                        minSize={100}
                        maxSize={1000000 * 200}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <>
                                <section className="contractDragndropSection">
                                    <div
                                        {...getRootProps({
                                            className: "dragndrop text-center",
                                        })}
                                    >
                                        <img src={imgUpload} />
                                        <p>
                                            {" "}
                                            Drag and drop the file <br /> or{" "}
                                            <span>browse</span> to choose a file{" "}
                                        </p>
                                        <input {...getInputProps()} />
                                    </div>
                                    {this.state.uploadFileError != null &&
                                        this.state.uploadFileError !== "" && (
                                            <p className="upload-error text-danger text-center">
                                                {this.state.uploadFileError}
                                            </p>
                                        )}
                                    {this.state.uploadFileSuccess != null &&
                                        this.state.uploadFileSuccess !== "" && (
                                            <p className="text-success text-center">
                                                {this.state.uploadFileSuccess}
                                            </p>
                                        )}
                                </section>
                                <section className="mobdragndrop">
                                    <div
                                        {...getRootProps({
                                            className: "dragndrop text-center",
                                        })}
                                    >
                                        <p>
                                            {" "}
                                            <span> + Upload file</span>{" "}
                                        </p>
                                        <input {...getInputProps()} />
                                    </div>
                                </section>
                            </>
                        )}
                    </Dropzone>
                    <div className="filesContainer">
                        {Object.entries(contractList).map((data, index) => (
                            <div key={index} className="file-uploadmain">
                                <a onClick={() => this.openDocModal(data[1])}>
                                    <div className="uploadfilename">
                                        <div className="pdfupload">
                                            {" "}
                                            <img src="/images/pdffile.svg" />{" "}
                                        </div>
                                        <div className="pdfname">
                                            <p>{data[1].file}</p>
                                        </div>
                                    </div>
                                </a>
                                <div className="uploadsuccc">
                                    <div
                                        className="uploaddelet"
                                        onClick={(evt) => {
                                            this.handleDelete(data[1].id);
                                        }}
                                    >
                                        <img
                                            src="/images/delet.svg"
                                            style={{ cursor: "pointer" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    {showSpinner ? (
                        <div className="spinner">
                            <Loader />
                        </div>
                    ) : (
                        ""
                    )}
                    <ShowDocsModal
                        isOpen={docModal}
                        close={() => this.closeDocModal()}
                        file={docModalFile}
                        fileType={docModalFileType}
                    />
                </div>
            </>
        );
    }
}

export default OrganizationContract;
